import { getUserIsAuthenticated } from "../../../selectors";
import { getBackInStock } from "../../../modules/backInStock/actions";
import clearNotificationsStorage from "../../../../services/pdp/clearNotificationsStorage";
import isBackInStockNotificationEnabled from "../../../modules/backInStock/isBackInStockEnabled";

const shouldCallBackInStock = state => getUserIsAuthenticated(state);

export const initialise =
  (savedItemsPromise, userIdentityPromise) => async (dispatch, getState) => {
    if (!isBackInStockNotificationEnabled()) {
      return Promise.all([savedItemsPromise, userIdentityPromise]);
    }

    clearNotificationsStorage();

    await userIdentityPromise;

    let backInStockPromise;
    const state = getState();
    if (shouldCallBackInStock(state)) {
      backInStockPromise = dispatch(getBackInStock());
    }

    const savedItems = await savedItemsPromise;
    if (savedItems?.length) {
      await backInStockPromise;
    }
  };
